module.exports = __webpack_public_path__ + "static/media/guy4.b81f115a.png";